/**
 * Yanchi Product Page
 * - Thumbnail rail (click to switch active image, syncs on swipe too)
 * - Tap-to-zoom lightbox on gallery images
 * - Sticky mobile "Add to Cart" bar, shown once the real button scrolls
 *   out of view (mirrors the collection-switcher pin technique already
 *   used elsewhere in this theme)
 * - Recently viewed products (client-side only, localStorage — no backend)
 */
(function () {
  'use strict';

  function initGalleryThumbs(root) {
    var gallery = root.querySelector('.yanchi-product__gallery');
    var thumbs = root.querySelectorAll('.yanchi-gallery-thumb');
    if (!gallery || !thumbs.length) return;

    var items = root.querySelectorAll('.yanchi-product__media-item');
    var thumbRail = root.querySelector('.yanchi-gallery-thumbs');

    function setActiveIndex(index, smooth) {
      var item = items[index];
      var activeThumb = thumbs[index];
      if (!item || !activeThumb) return;

      if (smooth && gallery.scrollTo) {
        gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      } else {
        gallery.scrollLeft = item.offsetLeft;
      }

      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('active', thumbIndex === index);
      });

      if (thumbRail) {
        var thumbLeft = activeThumb.offsetLeft - (thumbRail.clientWidth - activeThumb.offsetWidth) / 2;
        if (smooth && thumbRail.scrollTo) {
          thumbRail.scrollTo({ left: thumbLeft, behavior: 'smooth' });
        } else {
          thumbRail.scrollLeft = thumbLeft;
        }
      }
    }

    function selectMedia(mediaId, smooth) {
      if (!mediaId) return;
      for (var i = 0; i < items.length; i += 1) {
        if (items[i].dataset.mediaId === String(mediaId)) {
          setActiveIndex(i, smooth);
          return;
        }
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        setActiveIndex(i, true);
      });
    });

    gallery.addEventListener(
      'scroll',
      function () {
        var index = Math.round(gallery.scrollLeft / gallery.offsetWidth);
        thumbs.forEach(function (t, i) {
          t.classList.toggle('active', i === index);
        });
      },
      { passive: true }
    );

    selectMedia(root.dataset.selectedMediaId, false);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        var featuredMedia = variant && variant.featured_media;
        if (featuredMedia) selectMedia(featuredMedia.id, true);
      });
    }
  }

  function initZoomLightbox(root) {
    var images = root.querySelectorAll('.yanchi-product__media-item img');
    var lightbox = document.getElementById('yanchi-zoom-lightbox');
    var lightboxImg = document.getElementById('yanchi-zoom-lightbox-img');
    var closeBtn = document.getElementById('yanchi-zoom-lightbox-close');
    if (!images.length || !lightbox || !lightboxImg || !closeBtn) return;

    function open(src, alt) {
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
      // Empty string would make the browser re-request the current page as
      // an image; reset to the same inert placeholder used before first open.
      lightboxImg.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACw=';
    }

    images.forEach(function (img) {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function () {
        // Use the largest available width for the zoomed view.
        var full = img.currentSrc || img.src;
        open(full.replace(/width=\d+/, 'width=1600'), img.alt);
      });
    });

    closeBtn.addEventListener('click', close);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) close();
    });
  }

  function initStickyAtc(root) {
    var realBtn = root.querySelector('.yanchi-btn--atc');
    var stickyBar = document.getElementById('yanchi-sticky-atc');
    if (!realBtn || !stickyBar || !('IntersectionObserver' in window)) return;

    var srCheckout = root.querySelector('.yanchi-product__sr-checkout');
    var paymentBtnWrap = root.querySelector('.yanchi-product__payment-btn');

    var stickyBtn = stickyBar.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        // Prefer whichever "buy now" entry point is actually visible: the SR
        // Checkout headless button, then Shopify's dynamic checkout button,
        // falling back to plain Add to Cart only if neither is available.
        var srInner = srCheckout && srCheckout.firstElementChild;
        if (srInner && srCheckout.offsetParent !== null) {
          srInner.click();
          return;
        }
        var payBtn = paymentBtnWrap && paymentBtnWrap.querySelector('button, [role="button"], a');
        if (payBtn && paymentBtnWrap.offsetParent !== null) {
          payBtn.click();
          return;
        }
        realBtn.click();
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        stickyBar.classList.toggle('is-visible', !visible);
      },
      { threshold: 0 }
    );
    observer.observe(realBtn);

    // Keep the sticky bar's disabled state in sync with the real button
    // (variant changes, sold-out selections, etc. — product-info.js owns that logic).
    // Label stays "Buy Now" unless the variant is unavailable.
    var syncState = function () {
      if (!stickyBtn) return;
      stickyBtn.disabled = realBtn.disabled;
      var stickyLabel = stickyBtn.querySelector('[data-sticky-atc-label]');
      if (!stickyLabel) return;
      if (realBtn.disabled) {
        var label = realBtn.querySelector('span');
        stickyLabel.textContent = label ? label.textContent.trim() : 'Unavailable';
      } else {
        stickyLabel.textContent = 'Buy Now';
      }
    };
    var btnObserver = new MutationObserver(syncState);
    btnObserver.observe(realBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
    syncState();
  }

  function initSizeGuide(root) {
    var trigger = root.querySelector('[data-size-guide-trigger]');
    var modal = document.getElementById('yanchi-size-guide');
    var closeBtn = document.getElementById('yanchi-size-guide-close');
    if (!trigger || !modal || !closeBtn) return;

    trigger.addEventListener('click', function () {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
  }

  function initRecentlyViewed(root) {
    var STORAGE_KEY = 'yanchiRecentlyViewed';
    var MAX_ITEMS = 12;
    var MAX_SHOW = 8;

    var data = root.dataset;
    var current = {
      id: data.productId,
      url: data.productUrl,
      title: data.productTitle,
      image: data.productImage,
      price: data.productPrice,
    };
    if (!current.id) return;

    var stored = [];
    try {
      stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      stored = [];
    }

    var container = document.getElementById('yanchi-recently-viewed');
    if (container) {
      var toShow = stored.filter(function (p) {
        return p.id !== current.id;
      }).slice(0, MAX_SHOW);

      if (toShow.length > 0) {
        var track = container.querySelector('[data-recently-viewed-track]');
        track.innerHTML = toShow
          .map(function (p) {
            return (
              '<a href="' + p.url + '" class="yanchi-rv-card">' +
              '<div class="yanchi-rv-card__media"><img src="' + p.image + '" alt="" loading="lazy" width="300" height="375"></div>' +
              '<p class="yanchi-rv-card__title">' + p.title + '</p>' +
              '<p class="yanchi-rv-card__price">' + p.price + '</p>' +
              '</a>'
            );
          })
          .join('');
        container.hidden = false;
      }
    }

    // Record this product for future visits.
    stored = stored.filter(function (p) {
      return p.id !== current.id;
    });
    stored.unshift(current);
    stored = stored.slice(0, MAX_ITEMS);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (e) {
      // Storage can be unavailable in strict privacy modes — safe to skip.
    }
  }

  function init() {
    var root = document.querySelector('.yanchi-product-page');
    if (!root) return;
    initGalleryThumbs(root);
    initZoomLightbox(root);
    initStickyAtc(root);
    initSizeGuide(root);
    initRecentlyViewed(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
